export const EVENTS = {
  MEDIA_START: 3,
  MEDIA_STOP: 4,
  MEDIA_WATCH_MORE_FIVE_SECONDS: 5,
  AD_CLICK: 6,
  MEDIA_CLICK: 7,
  PREMIUM_MEDIA_CLICK: 8,
  SHARING_CLICK: 9,
}
